import http from "@/http";

const ProjetoStatusRecebimentoService = {
  async obterStatusRecebimento(sqProjetoVar) {
    try {
      const response = await http.get(
        `/api/astec/projetos/${sqProjetoVar}/status-recebimento`
      );
      const data = response.data;
      if (!data || data.status_recebimento === null || data.status_recebimento === undefined) {
        return null;
      }
      return data.status_recebimento;
    } catch (error) {
      console.error("Erro ao buscar status de recebimento:", error);
      return null;
    }
  }
};

export default ProjetoStatusRecebimentoService;
